import { OrganisationEntity } from "Models/Entities";
import { OrganisationBillingFields } from "../Billing/OrganisationBillingFields"
import { BusinessEntityPaymentDetailsFields } from "../Billing/BusinessEntityPaymentDetailsFields";

type Props = {
	organisation: OrganisationEntity;
}

export const OrganisationBilling: React.FunctionComponent<Props> = ({ organisation }) => {

	return (
		<div className="billing-section">
			<OrganisationBillingFields organisation={organisation}/>
			<BusinessEntityPaymentDetailsFields 
				isOrganisation
				organisation={organisation}
				businessEntityId={organisation.primaryBusinessEntity.id} 
			/>
		</div>
	)
}